import { AfterViewInit, ChangeDetectorRef, Component, OnInit, inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef, MatDialogTitle, MatDialogContent, MatDialogActions } from '@angular/material/dialog';
import {HydraService} from '../../../core/services/hydra.service';
import {AuthentificationService} from '../../../core/services/authentification.service';
import {ToolsService} from '../../services/tools/tools.service';
import { CdkScrollable } from '@angular/cdk/scrolling';
import { MatTabGroup, MatTab } from '@angular/material/tabs';
import { MatButton } from '@angular/material/button';

@Component({
    selector: 'app-modal-prev-notifs',
    templateUrl: './modal-prev-notifs.component.html',
    styleUrls: ['./modal-prev-notifs.component.scss'],
    imports: [MatDialogTitle, CdkScrollable, MatDialogContent, MatTabGroup, MatTab, MatDialogActions, MatButton]
})
export class ModalPrevNotifsComponent implements OnInit, AfterViewInit {
    private hydraService = inject(HydraService);
    dialogRef = inject<MatDialogRef<ModalPrevNotifsComponent>>(MatDialogRef);
    private authService = inject(AuthentificationService);
    data = inject(MAT_DIALOG_DATA);
    private detectorChange = inject(ChangeDetectorRef);
    private toolsService = inject(ToolsService);

    attachment: string = null;
    text: string = null;

    public iframeViewerBaseId = 'iFrameViewer';
    public mailKey = 'ContentFrame';
    public pieceKey = 'ContentFrame';


    constructor() {
    }

    onNoClick(): void {
        this.dialogRef.close();
    }

    ngOnInit() {
    }

    ngAfterViewInit(): void {
        this.getMail();
        this.detectorChange.detectChanges();
    }

    public clearIframe(id: string) {
        const iframes = document.getElementsByTagName('iframe');
        console.log(iframes, 'iframes');
        if (iframes && iframes.length) {
            for (let i = 0; i < iframes.length; i++) {
                iframes[i].remove();
            }
        }
    }

    public changeTab(index: number) {
        switch (index) {
            case 0 :
                this.getMail();
                break;
            case 1 :
                this.getAttachment();
                break;
        }
    }

    getMail() {
        this.clearIframe(this.mailKey);
        const locale = this.authService.userConnected.locale;
        const url = `/${locale}/decisions/${this.data.id}/email`;
        const sub = this.hydraService.getHtml(url).subscribe(res => {
            this.text = res;
            this.editHtml(res, this.mailKey);
            sub.unsubscribe();
        });
    }

    getAttachment() {
        this.clearIframe(this.pieceKey);
        const locale = this.authService.userConnected.locale;
        const url = `/${locale}/decisions/${this.data.id}/attachment/html`;

        const sub = this.hydraService.getHtml(url).subscribe(res => {
            this.text = res;
            this.editHtml(res, this.pieceKey);
            sub.unsubscribe();
        });
    }

    editHtml(html, id: string) {

        const iframe = document.createElement('iframe');
        if (document.getElementById(id)) {


            document.getElementById(id).appendChild(iframe);
            iframe.contentWindow.document.open();
            iframe.contentWindow.document.write(html);
            iframe.contentWindow.document.close();
            iframe.setAttribute('id', `${this.iframeViewerBaseId}${id}`);
            iframe.setAttribute('width', '100%');
            iframe.setAttribute('height', '100%');
            iframe.setAttribute('style', 'border:none; display:block;');


            window.setTimeout(() => {
                iframe.setAttribute(
                    'min-height',
                    iframe.contentWindow.document.body.scrollHeight + 'px'
                );
                iframe.setAttribute(
                    'height',
                    iframe.contentWindow.document.body.scrollHeight + 'px'
                );
            }, 500);
        }
    }

    public download() {
        const locale = this.authService.userConnected.locale;

        this.toolsService.download(
            {
                url: `/${locale}/decisions/${this.data.id}/attachment/pdf`,
                originalFilename: `Notif_attachments_${this.data.id}.pdf`
            }
        );
    }

}


